__turbopack_context__.v({
  "description": "InputLabel-module-scss-module__Wxc8AG__description",
  "descriptionWrapper": "InputLabel-module-scss-module__Wxc8AG__descriptionWrapper",
  "descriptionWrapperNoMargin": "InputLabel-module-scss-module__Wxc8AG__descriptionWrapperNoMargin",
  "fade-in": "InputLabel-module-scss-module__Wxc8AG__fade-in",
  "ghost": "InputLabel-module-scss-module__Wxc8AG__ghost" + " " + "InputLabel-module-scss-module__Wxc8AG__label",
  "label": "InputLabel-module-scss-module__Wxc8AG__label",
  "labelNoMargin": "InputLabel-module-scss-module__Wxc8AG__labelNoMargin",
  "meta": "InputLabel-module-scss-module__Wxc8AG__meta",
  "no-transform": "InputLabel-module-scss-module__Wxc8AG__no-transform",
  "rotate": "InputLabel-module-scss-module__Wxc8AG__rotate",
});
